import * as React from 'react';
import { useRef, useEffect } from 'react';
import Tabulator from 'tabulator-tables';
import { React15Tabulator } from 'react-tabulator';
// import 'tabulator-tables/dist/css/tabulator.min.css';
// import { spinnerSize, Title } from '@patternfly/react-core';
// import { Spinner } from '@patternfly/react-core';

interface SCTabulatorProps {
    data: any[];
    columns: any[];
    layout: string;
    options?: Record<string, unknown>;
    tableRef?: any;
}

const SCTabulator: React.FC<SCTabulatorProps> = ({ data, columns, layout, options, tableRef }) => {
    // let tabulator = useRef();
    const tabulatorElement = useRef(null);

    useEffect(() => {
        const tabulator = new Tabulator(tabulatorElement.current, {
            ...options,
            data: data,
            columns: columns,
            layout: layout,
            reactiveData: true
        });
        // TODO: This is a leftover from how ReactTabulator did things. Clean it up if we go this route.
        if (tableRef) {
            tableRef({table: tabulator});
        }
    }, [data, tableRef]);


    return (<div ref={tabulatorElement} />);

};

export default SCTabulator;